export const RESET_GLOBAL_STATE = '@GLOBAL/RESET_STATE';
export const UNKNOWN = '@GLOBAL/UNKNOWN';

export interface ResetGlobalState {
  type: typeof RESET_GLOBAL_STATE;
}

export interface Unknown {
  type: typeof UNKNOWN;
}

export type GlobalActionTypes = ResetGlobalState | Unknown;
